import * as React from 'react';
import { triggerTracking } from '@zoopla/tracking';
import { Box } from '@zoopla-eng/zds-components/box';
import { Link } from '@zoopla-eng/zds-components/link';
import { useLinkWithParam } from '@zoopla/authentication/helpers';
import { fontGroups } from '@zoopla-eng/zds-components/themes';
import { ZooplaLogo } from '@zoopla/assets';
import {
    signInPageHeaderHeadingStyle,
    signInPageHeaderLogoStyle,
    signInPageHeaderWrapperStyle
} from './SignInPageHeader.styles.css';

type Props = {
    registerUrl?: string;
};

const SignInPageHeader: React.FC<React.PropsWithChildren<Props>> = ({
    registerUrl = '/register/'
}) => {
    return (
        <Box pt="S500" pb="M100">
            <div
                className={signInPageHeaderWrapperStyle}
                data-testid="sign-in-page-header"
            >
                <Box pb="S500">
                    <Link
                        data-testid="sign-in-page-logo-link"
                        href="/"
                        title="Return to zoopla home page"
                        onClick={() =>
                            triggerTracking({
                                event: 'GAEvent',
                                eventCategory: 'signin',
                                eventAction: 'click_to_homepage',
                                eventLabel: '/signin/'
                            })
                        }
                    >
                        <div className={signInPageHeaderLogoStyle}>
                            <ZooplaLogo />
                        </div>
                    </Link>
                </Box>
                <Box pb="S500">
                    <h1
                        className={`${signInPageHeaderHeadingStyle} ${fontGroups.kettle}`}
                        data-testid="sign-in-page-header-heading"
                    >
                        Sign in to save properties and much more
                    </h1>
                </Box>
                <div
                    className={fontGroups.ladle}
                    data-testid="sign-in-page-header-subheading"
                >
                    No account?
                    <Box pl="S200" display="inline-block">
                        <Link
                            data-testid="sign-in-page-header-register-link"
                            href={useLinkWithParam(registerUrl, true)}
                            onClick={() =>
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'signin',
                                    eventAction: 'click_to_register',
                                    eventLabel: '/signin/'
                                })
                            }
                        >
                            Register
                        </Link>
                    </Box>
                </div>
            </div>
        </Box>
    );
};

export default SignInPageHeader;
